import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIFormControlLabel(theme: Theme): Components['MuiFormControlLabel'] {
  return {
    styleOverrides: {
      root: {
        marginLeft: 0,
        marginRight: 0,
      },
      label: {
        ...theme.typography.body2,
      },
    },
  };
}
